@if (isEditing && editable) {
  <div class="header-select-container editing">
    <input
      class="header-select-edit-input"
      type="text"
      [value]="editingValue"
      (input)="onEditInput($event)"
      (keydown)="onEditKeydown($event)"
      (blur)="onEditBlur()"
      maxlength="100" />
    <button class="header-select-edit-save" (mousedown)="$event.preventDefault()" (click)="onEditSaveClick($event)">
      <span class="material-icons">check</span>
    </button>
  </div>
} @else {
  <div class="header-select-container" (click)="toggleDropdown($event)">
    @if (icon) {
      <div class="select-icon">
        <tidy-image [src]="icon" />
      </div>
    }
    @if (showIcons && getSelectedIcon()) {
      <span class="material-icons selected-icon" [style.color]="getSelectedIconColor()">{{ getSelectedIcon() }}</span>
    }
    <span class="header-select-value">{{ getSelectedViewValue() }}</span>
    <div class="select-arrow">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M5 4.5L8 2L11 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5 11.5L8 14L11 11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>
}
@if (isOpen) {
  <div class="header-select-dropdown">
    @if (showSearch) {
      <div class="dropdown-search">
        <tidy-image [src]="'assets/svg/search.svg'" class="search-icon" />
        <input
          #searchInput
          type="text"
          class="search-input"
          [placeholder]="'Search' | translate"
          (input)="onSearchInputChange()"
          (keyup)="onSearchInputChange()"
          (click)="$event.stopPropagation()"
        />
        @if (searchValue) {
          <button class="clear-button" (click)="clearSearch(); $event.stopPropagation()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    }
    <div class="header-select-dropdown-list">
      @for (item of filteredItems; track item.value) {
        <div
          class="header-select-dropdown-item"
          [class.selected]="item.value === value"
          [class.rich-item]="richItems"
          (click)="selectItem(item, $event)">
          @if (showIcons && item.icon) {
            <span class="material-icons item-icon" [style.color]="item.iconColor || null">{{ item.icon }}</span>
          }
          <div class="item-content">
            <tidy-text [body]="item.viewValue" />
            @if (richItems && item.subtitle) {
              <span class="item-subtitle">{{ item.subtitle }}</span>
            }
            @if (richItems && item.metadata) {
              <span class="item-metadata">{{ item.metadata }}</span>
            }
          </div>
          @if (showItemActions) {
            <div class="item-actions">
              <button class="item-action-btn edit-action" (click)="onEditItemClick(item, $event)" title="Edit">
                <span class="material-icons">edit</span>
              </button>
              <button class="item-action-btn delete-action" (click)="onDeleteItemClick(item, $event)" title="Delete">
                <span class="material-icons">delete</span>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>
}
